import { render, staticRenderFns } from "./KFixedGridItem.vue?vue&type=template&id=10bf1b53&scoped=true&"
import script from "./KFixedGridItem.vue?vue&type=script&lang=js&"
export * from "./KFixedGridItem.vue?vue&type=script&lang=js&"
import style0 from "./KFixedGridItem.vue?vue&type=style&index=0&id=10bf1b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf1b53",
  null
  
)

export default component.exports